import setCookie from "@/utils/setCookie"
import { ContactTokens } from '../../../../requests-module'

const setTokensInCookies = (tokens: ContactTokens) => {
    setCookie('user-access-token', tokens.accessToken)
    setCookie('user-id-token', tokens.idToken)
    setCookie('user-refresh-token', tokens.refreshToken)
}

export default setTokensInCookies